import React from 'react';
import cn from 'classnames';

import SalonModal from 'components/dialog/SalonModal.component';
import Button from 'components/form/Button.component';
import ToggleSwitch from 'components/form/ToggleSwitch.component';
import ToggleSwitchPanel from 'components/form/ToggleSwitchPanel.component';
import Icon from 'components/generic/Icon.component';
import IconStatus from 'components/generic/IconStatus.component';
import OverlaySpinner from 'components/generic/OverlaySpinner.component';
import CurrencySign from 'components/price/CurrencySign.component';
import DELAY from 'constants/delay.const';
import S from 'constants/string.const';
import { withTranslation } from 'providers/GILT.provider';
import { withTheme } from 'providers/Theme.provider';
import delayed from 'utils/functions/delayed.util';
import logger from 'utils/logger.util';

import RadioFormContainer from 'onboarding/common/RadioForm';

import CN from './ManageItemsSidebar.module.scss';

const L = logger('ManageItemsSidebar');

const PRICE_ROUNDING = Object.freeze({
  to49: '0.49',
  toHalf: '0.5',
  to99: '0.99',
  toWhole: '1',
});

class ManageItemsSidebar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentData: this.props.data,
      filterB: '',
      filterSub: '',
      filterCat: '',
      updateModal: false,
      isLoading: false,
      listBrand: false,
      listSubBrand: false,
      listCategory: false,
      saveSubBrand: false,
      saveBrand: false,
      saveCategory: false,
      incrRetail: true,
      incrCost: true,
      value: '',
      value2: '',
      disableRadioGroup: true,
      selectedOption: '',
      costPrice: '',
      costPricePercent: '',
      retailPrice: '',
      retailPricePercent: '',
    };
  }

  // noinspection JSCheckFunctionSignatures
  UNSAFE_componentWillReceiveProps(nextProps) {
    const countSelected = nextProps.data.filter((c) => c.selected === true);
    const currSelected = this.state.currentData.filter((c) => c.selected === true);
    if (countSelected.length !== currSelected.length) {
      if (this.state.retailPrice !== '' || this.state.retailPricePercent !== '') {
        this.onApplyRetailPrice(this.state.retailPrice, this.state.selectedOption, this.state.incrRetail, this.state.retailPricePercent);
      }
      if (this.state.costPrice !== '' || this.state.costPricePercent !== '') {
        this.onApplyCostPrice(this.state.costPrice, this.state.incrCost, this.state.costPricePercent);
      }
    }
  }

  onSave = () => {
    this.setState({ updateModal: true });
  };

  onConfirmUpdate = () => {
    this.setState({ isLoading: true });

    delayed(DELAY.fast, () => {
      this.props
        .onUpdateItems(this.state.filterB, this.state.filterSub, this.state.filterCat)
        .then(() => {
          this.setState({ updateModal: false, isLoading: false });
        })
        .catch((error) => {
          this.setState({ isLoading: false });
          L.debug('onConfirmUpdate()', 'Error:', error);
        });
    });
  };

  onClose = () => {
    this.props.onClose();
    this.props.revertCostorRetailPrice();
  };

  onSwitchCostRadio = (event) => {
    const costPrice = document.getElementById('costPrice');
    const costPriceByPercent = document.getElementById('costPriceByPercent');

    this.setState({
      value: event.currentTarget.value,
    });
    this.props.revertCostorRetailPrice();
    if (this.state.retailPrice !== '' || this.state.retailPricePercent !== '') {
      this.onApplyRetailPrice(this.state.retailPrice, this.state.selectedOption, this.state.incrRetail, this.state.retailPricePercent);
    }
    // cost
    if (event.currentTarget.value === 'cost-price') {
      if (costPrice) {
        costPrice.focus();
      }

      this.setState({
        costPricePercent: '',
      });
    }
    if (event.currentTarget.value === 'cost-price-increase') {
      if (costPriceByPercent) {
        costPriceByPercent.focus();
      }
      this.setState({
        costPrice: '',
      });
    }
  };
  onSwitchRetailRadio = (event) => {
    const retailPrice = document.getElementById('retailPrice');
    const retailPriceByPercent = document.getElementById('retailPriceByPercent');

    this.setState({
      value2: event.currentTarget.value,
    });
    this.props.revertCostorRetailPrice();
    if (this.state.costPrice !== '' || this.state.costPricePercent !== '') {
      this.onApplyCostPrice(this.state.costPrice, this.state.incrCost, this.state.costPricePercent);
    }
    // retail
    if (event.currentTarget.value === 'retail-price') {
      if (retailPrice) {
        retailPrice.focus();
      }

      this.setState({
        disableRadioGroup: true,
        retailPricePercent: '',
      });
    }
    if (event.currentTarget.value === 'retail-price-increase') {
      if (retailPriceByPercent) {
        retailPriceByPercent.focus();
      }
      this.setState({
        retailPrice: '',
      });
    }
  };
  onCostPriceChange = (event) => {
    const parseValue = parseFloat(event.target.value);
    let setPrice;
    // eslint-disable-next-line use-isnan
    if (parseValue && parseValue !== NaN) {
      setPrice = event.target.value;
    } else {
      setPrice = '';
    }
    this.onApplyCostPrice(setPrice, this.state.incrCost, '');
    this.setState({
      value: 'cost-price',
      costPrice: setPrice,
      costPricePercent: '',
    });
  };
  onApplyCostPrice = (setPrice, incrCost, setPercentage) => {
    this.props.applyCostPriceChange(setPrice, incrCost, setPercentage);
    this.setState({
      currentData: this.props.data,
    });
  };
  onApplyRetailPrice = (setPrice, selectedValue, incrRetail, setPersentage) => {
    this.props.applyRetailPriceChange(setPrice, incrRetail, setPersentage, selectedValue);
    this.setState({
      currentData: this.props.data,
    });
  };
  onRetailPriceChange = (event) => {
    const parseValue = parseFloat(event.target.value);
    let setPrice;
    // eslint-disable-next-line use-isnan
    if (parseValue && parseValue !== NaN) {
      setPrice = event.target.value;
    } else {
      setPrice = '';
    }
    this.onApplyRetailPrice(setPrice, this.state.selectedOption, this.state.incrRetail, '');
    this.setState({
      value2: 'retail-price',
      retailPrice: setPrice,
      retailPricePercent: '',
    });
  };
  onRetailByPercent = (event) => {
    const parseValue = parseFloat(event.target.value);
    if (this.state.retailPricePercent === '') {
      this.props.revertCostorRetailPrice();
      if (this.state.costPrice !== '' || this.state.costPricePercent !== '') {
        this.onApplyCostPrice(this.state.costPrice, this.state.incrCost, this.state.costPricePercent);
      }
    }
    let setPrice;
    // eslint-disable-next-line use-isnan
    if (parseValue && parseValue !== NaN) {
      setPrice = event.target.value;
    } else {
      setPrice = '';
    }
    this.onApplyRetailPrice('', this.state.selectedOption, this.state.incrRetail, setPrice);
    this.setState({
      retailPricePercent: setPrice,
      value2: 'retail-price-increase',
      retailPrice: '',
    });

    const valuePercent = event.target.value;
    if (valuePercent) {
      this.setState({
        disableRadioGroup: false,
      });
    } else {
      this.setState({
        disableRadioGroup: true,
      });
    }
  };
  onCostByPercent = (event) => {
    const parseValue = parseFloat(event.target.value);
    if (this.state.costPricePercent === '') {
      this.props.revertCostorRetailPrice();
      if (this.state.retailPrice !== '' || this.state.retailPricePercent !== '') {
        this.onApplyRetailPrice(this.state.retailPrice, this.state.selectedOption, this.state.incrRetail, this.state.retailPricePercent);
      }
    }
    let setPrice;
    // eslint-disable-next-line use-isnan
    if (parseValue && parseValue !== NaN) {
      setPrice = event.target.value;
    } else {
      setPrice = '';
    }
    this.onApplyCostPrice('', this.state.incrCost, setPrice);
    this.setState({
      costPricePercent: setPrice,
      value: 'cost-price-increase',
      costPrice: '',
    });
  };
  onCostIncr = (setValue) => {
    this.props.revertCostorRetailPrice();
    this.setState({ incrCost: setValue });
    if (this.state.retailPrice !== '' || this.state.retailPricePercent !== '') {
      this.onApplyRetailPrice(this.state.retailPrice, this.state.selectedOption, this.state.incrRetail, this.state.retailPricePercent);
    }
    this.onApplyCostPrice('', setValue, this.state.costPricePercent);
  };
  onRetailIncr = (setValue) => {
    this.props.revertCostorRetailPrice();
    this.setState({ incrRetail: setValue });
    if (this.state.costPrice !== '' || this.state.costPricePercent !== '') {
      this.onApplyCostPrice(this.state.costPrice, this.state.incrCost, this.state.costPricePercent);
    }
    this.onApplyRetailPrice('', this.state.selectedOption, setValue, this.state.retailPricePercent);
  };
  switchRadio = (selectedValue) => {
    this.setState({ selectedOption: selectedValue });
    this.onApplyRetailPrice('', selectedValue, this.state.incrRetail, this.state.retailPricePercent);
  };
  // brand
  selectBrand = (item) => {
    this.setState({
      filterB: item,
      listBrand: false,
    });
  };
  searchBrand = (event) => {
    this.setState({ filterB: event.target.value, listBrand: true });
  };
  // sub brand
  selectSubBrand = (item) => {
    this.setState({
      filterSub: item,
      listSubBrand: false,
    });
  };
  searchSubBrand = (event) => {
    this.setState({ filterSub: event.target.value, listSubBrand: true });
  };
  // category
  selectCategory = (item) => {
    this.setState({
      filterCat: item,
      listCategory: false,
    });
  };
  searchCategory = (event) => {
    this.setState({ filterCat: event.target.value, listCategory: true });
  };

  // TODO:convert to func. component and update styles
  render() {
    const { filterB, filterSub, filterCat, updateModal, isLoading } = this.state;
    const { isDarkMode, t } = this.props;
    // brands
    const lowercasedFilter = filterB ? filterB.replace(/’/, '').replace(/'/, '').toLowerCase() : '';
    const filteredData = this.props.brandList.filter((item) =>
      item
        .trim()
        .normalize('NFD')
        .replace(/^0+/, '')
        .replace(/’/, '')
        .replace(/'/, '')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .replace(/[\u00E9]/g, '')
        .toLowerCase()
        .includes(
          lowercasedFilter
            .normalize('NFD')
            .replace(/[\u00E9]/g, '')
            .replace(/[\u0300-\u036f]/g, ''),
        ),
    );
    // sub brands
    const lowercasedFilterSub = filterSub.replace(/’/, '').replace(/'/, '').toLowerCase();
    const filteredDataSub = this.props.subBrandList.filter((item) =>
      item
        .toLowerCase()
        .trim()
        .normalize('NFD')
        .replace(/^0+/, '')
        .replace(/’/, '')
        .replace(/'/, '')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .replace(/[\u00E9]/g, '')
        .toLowerCase()
        .includes(
          lowercasedFilterSub
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .replace(/[\u00E9]/g, ''),
        ),
    );
    const lowercasedFilterCat = filterCat.replace(/’/, '').replace(/'/, '').toLowerCase();
    const filteredDataCat = this.props.categoryList.filter((item) =>
      item
        .toLowerCase()
        .trim()
        .normalize('NFD')
        .replace(/^0+/, '')
        .replace(/’/, '')
        .replace(/'/, '')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .replace(/[\u00E9]/g, '')
        .toLowerCase()
        .includes(
          lowercasedFilterCat
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .replace(/[\u00E9]/g, ''),
        ),
    );

    const selectedProducts = this.props.data.filter((c) => c.selected === true).length;
    const productText =
      selectedProducts === 1
        ? t('stocks.managerLayout.sidebarProductProfile.updateItemModal.titlePart2')
        : selectedProducts > 1
          ? t('stocks.managerLayout.sidebarProductProfile.updateItemModal.titlePart3', { products: selectedProducts })
          : t('stocks.managerLayout.sidebarProductProfile.updateItemModal.titlePart4');

    return (
      <div
        data-bem="RemindersLayout"
        className={cn({
          [CN.component]: true,
          [CN.dark]: isDarkMode,
        })}
      >
        <div className="sidebar-header stock">
          <div className={CN.title}>
            <span>{selectedProducts} </span>
            {selectedProducts === 1 ? t('stocks.managerLayout.sidebarProductProfile.selectedProduct') : t('stocks.managerLayout.sidebarProductProfile.selectedProducts')}
          </div>
          <div role="button" tabIndex={0} className="close-button ico-close" onClick={this.onClose} />
        </div>
        <div className="sidebar-content manage-product">
          <div className={CN.text}>
            {t('stocks.managerLayout.sidebarProductProfile.updateDescriptionPart1')}
            <div className={CN.italic}>{t('stocks.managerLayout.sidebarProductProfile.updateDescriptionPart2')}</div>
          </div>
          <section>
            <div className="cfix search-filter">
              <label htmlFor="brand-dropdown">{t('stocks.managerLayout.sidebarProductProfile.brand')}</label>
              <input
                value={filterB}
                onClick={() => {
                  this.setState({ listSubBrand: false, listCategory: false });
                }}
                onChange={this.searchBrand}
                onBlur={() => this.setState({ saveBrand: false })}
                type="text"
                className="input-default"
                placeholder={t('stocks.managerLayout.sidebarProductProfile.searchBrandsPlaceholder')}
              />
              {this.state.listBrand === true && this.state.filterB.length > 0 && (
                <div className="dropdown-suggestions">
                  {filteredData.length === 0 && !this.state.saveBrand && (
                    <div className="btn-add-new-brand" key="btn-add-key" role="button" tabIndex="0" onClick={() => this.setState({ saveBrand: true })}>
                      {t('stocks.managerLayout.sidebarProductProfile.asNewBrandButton')}
                    </div>
                  )}
                  {filteredData.map((item) => (
                    <div
                      className="item"
                      key={item}
                      onClick={() => {
                        this.selectBrand(item);
                      }}
                      role="menuitem"
                      tabIndex="0"
                    >
                      <div>{item}</div>
                    </div>
                  ))}
                </div>
              )}
            </div>
            <div className="cfix search-filter">
              <label htmlFor="category">{t('stocks.managerLayout.sidebarProductProfile.subBrand')}</label>
              <input
                value={filterSub}
                onBlur={() => {
                  this.setState({ saveSubBrand: false });
                }}
                onClick={() => {
                  this.setState({ listBrand: false, listCategory: false });
                }}
                onChange={this.searchSubBrand}
                type="text"
                className="input-default"
                placeholder={t('stocks.managerLayout.sidebarProductProfile.subBrandPlaceholder')}
              />
              {this.state.listSubBrand === true && this.state.filterSub.length > 0 && (
                <div className="dropdown-suggestions">
                  {filteredDataSub.length === 0 && !this.state.saveSubBrand && (
                    <div className="btn-add-new-brand" key="btn-add-key" role="button" tabIndex="0" onClick={() => this.setState({ saveSubBrand: true })}>
                      {t('stocks.managerLayout.sidebarProductProfile.asNewSubBrandButton')}
                    </div>
                  )}
                  {filteredDataSub.map((item) => (
                    <div className="item" key={item} onClick={() => this.selectSubBrand(item)} role="menuitem" tabIndex="0">
                      <div>{item}</div>
                    </div>
                  ))}
                </div>
              )}
            </div>
            <div className="cfix search-filter">
              <label htmlFor="category">{t('stocks.managerLayout.sidebarProductProfile.category')}</label>
              <input
                value={filterCat}
                onBlur={() => {
                  this.setState({ saveCategory: false });
                }}
                onClick={() => {
                  this.setState({ listBrand: false });
                }}
                onChange={this.searchCategory}
                type="text"
                className="input-default"
                placeholder={t('stocks.managerLayout.sidebarProductProfile.categoryPlaceholder')}
              />
              {this.state.listCategory === true && this.state.filterCat.length > 0 && (
                <div className="dropdown-suggestions">
                  {filteredDataCat.length === 0 && !this.state.saveCategory && (
                    <div className="btn-add-new-brand" key="btn-add-key" role="button" tabIndex="0" onClick={() => this.setState({ saveCategory: true })}>
                      {t('stocks.managerLayout.sidebarProductProfile.asNewCategoryButton')}
                    </div>
                  )}
                  {filteredDataCat.map((item) => (
                    <div className="item" key={item} onClick={() => this.selectCategory(item)} role="menuitem" tabIndex="0">
                      <div>{item}</div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </section>

          <div id="bulk-edit">
            <section className={CN.container}>
              <span className={CN.text}>{t('stocks.managerLayout.sidebarProductProfile.updateCostPrices')}</span>
              <div className="row radio-group">
                <label className="radio-btn" htmlFor="c1">
                  <input id="c1" value="cost-price" name="c1" type="radio" checked={this.state.value === 'cost-price'} onChange={this.onSwitchCostRadio} />
                  <span className="checkmark" />
                  <div className="radio-text">
                    <span className="text-before">{t('stocks.managerLayout.sidebarProductProfile.costPriceCheckbox1Part1')}</span>
                    <div className="input-price">
                      <CurrencySign />
                      <input name="costPrice" type="text" className="input-default" id="costPrice" value={this.state.costPrice} onChange={this.onCostPriceChange} />
                    </div>
                    <span className="text-after">{t('stocks.managerLayout.sidebarProductProfile.priceCheckboxPart2')}</span>
                  </div>
                </label>
                <span className={CN.text}>{t('common.orUpp')}</span>
                <label className="radio-btn c2" htmlFor="c2">
                  <input id="c2" value="cost-price-increase" name="c2" type="radio" checked={this.state.value === 'cost-price-increase'} onChange={this.onSwitchCostRadio} />
                  <span className="checkmark for-percent" />
                  <div className="radio-text for-percent">
                    <div className="toggle-btns small">
                      <ToggleSwitchPanel>
                        <ToggleSwitch
                          selected={this.state.incrCost}
                          onClick={() => {
                            this.onCostIncr(true);
                          }}
                          name={t('stocks.managerLayout.sidebarProductProfile.increase')}
                          size="small"
                        />
                        <ToggleSwitch
                          selected={!this.state.incrCost}
                          onClick={() => {
                            this.onCostIncr(false);
                          }}
                          name={t('stocks.managerLayout.sidebarProductProfile.decrease')}
                          size="small"
                        />
                      </ToggleSwitchPanel>
                    </div>
                    <span className="text-before">{t('stocks.managerLayout.sidebarProductProfile.costPricesBy')}</span>
                    <div className="input-percent">
                      <input value={this.state.costPricePercent} name="costPriceByPercent" type="text" className="input-default" id="costPriceByPercent" onChange={this.onCostByPercent} />
                    </div>
                    <span className="text-after">{S.percent}</span>
                  </div>
                </label>
              </div>
            </section>

            <section className="retail-container">
              <span className={CN.text}>{t('stocks.managerLayout.sidebarProductProfile.updateRetailPrices')}</span>
              <div className="row radio-group">
                <label className="radio-btn" htmlFor="r1">
                  <input id="r1" value="retail-price" name="r1" type="radio" checked={this.state.value2 === 'retail-price'} onChange={this.onSwitchRetailRadio} />
                  <span className="checkmark" />
                  <div className="radio-text">
                    <span className="text-before">{t('stocks.managerLayout.sidebarProductProfile.retailPriceCheckbox2Part1')}</span>
                    <div className="input-price">
                      <CurrencySign />
                      <input name="retailPrice" type="text" className="input-default" id="retailPrice" value={this.state.retailPrice} onChange={this.onRetailPriceChange} />
                    </div>
                    <span className="text-after">{t('stocks.managerLayout.sidebarProductProfile.priceCheckboxPart2')}</span>
                  </div>
                </label>
                <span className={CN.text}>{t('common.orUpp')}</span>
                <label className="radio-btn" htmlFor="r2">
                  <input id="r2" value="retail-price-increase" name="r2" type="radio" checked={this.state.value2 === 'retail-price-increase'} onChange={this.onSwitchRetailRadio} />
                  <span className="checkmark for-percent" />
                  <div className="radio-text for-percent">
                    <div className="toggle-btns small">
                      <ToggleSwitchPanel>
                        <ToggleSwitch
                          selected={this.state.incrRetail}
                          onClick={() => {
                            this.onRetailIncr(true);
                          }}
                          name={t('stocks.managerLayout.sidebarProductProfile.increase')}
                          size="small"
                        />
                        <ToggleSwitch
                          selected={!this.state.incrRetail}
                          onClick={() => {
                            this.onRetailIncr(false);
                          }}
                          name={t('stocks.managerLayout.sidebarProductProfile.decrease')}
                          size="small"
                        />
                      </ToggleSwitchPanel>
                    </div>
                    <span className="text-before">{t('stocks.managerLayout.sidebarProductProfile.retailPricesBy')}</span>
                    <div className="input-percent">
                      <input value={this.state.retailPricePercent} name="retailPriceByPercent" type="text" className="input-default" id="retailPriceByPercent" onChange={this.onRetailByPercent} />
                    </div>
                    <span className="text-after">{S.percent}</span>
                  </div>
                </label>
              </div>
              <div className="text-for-group">
                {t('stocks.managerLayout.sidebarProductProfile.roundRetailPrices')}
                {S.space}
                {this.state.selectedOption && <CurrencySign />}
                {this.state.selectedOption}
              </div>
            </section>

            <div className="row radio-group round-option">
              <div className={this.state.disableRadioGroup ? 'disable-radios' : null}>
                <RadioFormContainer
                  selections={[
                    {
                      id: PRICE_ROUNDING.to49,
                      label: (
                        <>
                          <CurrencySign value={PRICE_ROUNDING.to49} />
                        </>
                      ),
                      name: PRICE_ROUNDING.to49,
                      checked: this.state.selectedOption === PRICE_ROUNDING.to49,
                    },
                    {
                      id: PRICE_ROUNDING.toHalf,
                      label: (
                        <>
                          <CurrencySign value={PRICE_ROUNDING.toHalf} />
                        </>
                      ),
                      name: PRICE_ROUNDING.toHalf,
                      checked: this.state.selectedOption === PRICE_ROUNDING.toHalf,
                    },
                    {
                      id: PRICE_ROUNDING.to99,
                      label: (
                        <>
                          <CurrencySign value={PRICE_ROUNDING.to99} />
                        </>
                      ),
                      name: PRICE_ROUNDING.to99,
                      checked: this.state.selectedOption === PRICE_ROUNDING.to99,
                    },
                    {
                      id: PRICE_ROUNDING.toWhole,
                      label: (
                        <>
                          <CurrencySign />
                          {PRICE_ROUNDING.toWhole}
                        </>
                      ),
                      name: PRICE_ROUNDING.toWhole,
                      checked: this.state.selectedOption === PRICE_ROUNDING.toWhole,
                    },
                  ]}
                  onChange={(e) => {
                    const selectedValue = e ? e.target.value : '';
                    this.switchRadio(selectedValue.toString());
                  }}
                />
              </div>
            </div>
          </div>
        </div>
        <footer className="product-sidebar-footer manage-product">
          <div className="cfix relative">
            <button onClick={this.onSave} className="btn btn-violet">
              {selectedProducts === 1 ? t('stocks.managerLayout.sidebarProductProfile.updateItemBtn') : t('stocks.managerLayout.sidebarProductProfile.updateItemsBtn')}
            </button>
          </div>
          <div className="cfix relative">
            <button onClick={this.props.onDelete} className="btn btn-red">
              {selectedProducts === 1 ? t('stocks.managerLayout.sidebarProductProfile.deleteItemBtn') : t('stocks.managerLayout.sidebarProductProfile.deleteItemsBtn')}
            </button>
          </div>
        </footer>

        {updateModal && (
          <SalonModal tag="KpiSummary__modal--kpi" isOpen withFooter>
            <SalonModal.Body>
              <div className={CN.image}>
                <IconStatus variant="alert">
                  <Icon variant="alert" />
                </IconStatus>
              </div>
              <div className={CN.modalContent}>
                <div className={CN.modalTitle}>
                  {t('stocks.managerLayout.sidebarProductProfile.updateItemModal.titlePart1')} {productText}.
                </div>
                <span className={CN.modalText}>{t('stocks.managerLayout.sidebarProductProfile.updateItemModal.description')}</span>
              </div>
            </SalonModal.Body>
            <SalonModal.Footer>
              <div className={CN.modalFooter}>
                <Button variant="primaryForce" onClick={() => this.setState({ updateModal: false })}>
                  <span className={CN.buttonGap}>{t('common.buttons.cancelUpp')}</span>
                </Button>
                <Button variant="primaryForce" onClick={this.onConfirmUpdate}>
                  <span className={CN.buttonGap}>{t('common.buttons.confirmUpp')}</span>
                </Button>
              </div>
            </SalonModal.Footer>
          </SalonModal>
        )}
        {isLoading && <OverlaySpinner />}
      </div>
    );
  }
}

export default withTranslation()(withTheme()(ManageItemsSidebar));
